import React from 'react';

import { useApi } from './axios';

export const useSignS3Url = () => {
    const api = useApi();
    return React.useCallback((url: string) => api.post('s3/sign-url', { url }) as Promise<string>, []);
};
